import React from 'react';
import { useUser } from '../../context/UserContext';
import { useParams } from 'react-router-dom';

// Import components for different user roles
import LandingInstrumentDetails from '../LandingPages/InstrumentDetails'; // For external users

const ConditionalInstrumentDetailsRoute = () => {
  const { userData } = useUser();
  const { isin } = useParams();

  // Check if user is external (only EXTERNAL_USER role)
  const isExternalUser = () => {
    if (!userData || !userData.roles || userData.roles.length === 0) {
      return true; // Default to external if no roles
    }
    
    // Check if user has EXTERNAL_USER role
    return userData.roles.includes('EXTERNAL_USER');
  };

  // Render appropriate component based on user role
  if (isExternalUser()) {
    console.log('Rendering external InstrumentDetails component for user:', userData?.username);
    return <LandingInstrumentDetails skipLayout={true} />;
  } else {
    console.log('Rendering internal InstrumentDetails component for user:', userData?.username);
    // For now, use the same component since there might not be a separate admin version
    return <LandingInstrumentDetails skipLayout={true} />;
  }
};

export default ConditionalInstrumentDetailsRoute;
